import React, {Component, ChangeEvent, FormEvent} from 'react';
import {connect} from 'react-redux';
import {AxiosPromise} from 'axios';
import {LOGIN} from '@optimaxdev/analytics/mobile';

import {VoidFunctionType} from '@typescript/common/functionTypes';
import {ActionType} from '@typescript/common/actionTypes';
import Input from 'components/__helpers/input/input';
import {ValidationAuthorizationForgot} from 'libs/validation/validationField';
import {sendForgot} from 'actions/authorization/authorization';
import {sendAnalytics} from 'features/wizardMs/utils/sendAnalytics';

import s from './forgot.scss';

type PropsType = {
    formKey: string;
    visibleTabHandler: VoidFunctionType<string>;
    sendForgot: (email: string, formKey: string) => ActionType<AxiosPromise>;
};

type StateType = {
    email: string;
    error: string;
    success: string;
};

/**
 * Forgot authorization component
 */
export class Forgot extends Component<PropsType, StateType> {
    state = {
        email: '',
        error: '',
        success: '',
    };

    /**
     * Set success state and cancel it
     */
    setSuccess = () => {
        this.setState({success: 'Email sent. Check your inbox.'});
        setTimeout(() => {
            this.setState({success: ''});
        }, 5000);
    };

    /**
     * Function handle for submit
     * @param {FormEvent<HTMLButtonElement>} event - JS event
     */
    handleSubmit = (event: FormEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.setState({error: ''});
        sendAnalytics(LOGIN.RESET_PASSWORD, 'Submit');
        this.props
            .sendForgot(this.state.email, this.props.formKey)
            // @ts-ignore
            .then(() => this.setSuccess())
            .catch((data: {response: {data: {message: string}}}) => {
                this.setState({error: data.response.data.message});
            });
    };

    /**
     * Change handler input
     * @param {ChangeEvent<HTMLInputElement>} event - Event object
     */
    changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        this.setState({[name]: value} as Pick<StateType, keyof StateType>);
    };

    /**
     * Render jsx to html
     * @returns {ReactNode} Rendered react component
     */
    render() {
        const {visibleTabHandler} = this.props;
        const {error, email, success} = this.state;
        return (
            <div>
                <div className={s.forgot}>
                    <p className={s.heading}>Forgot Your Password?</p>
                    <p className={s.description}>
                        Please enter your email below and we’ll send you a new password.
                    </p>
                    <form>
                        <div className={s.inputBlock}>
                            <Input
                                type="email"
                                error={error}
                                onChange={this.changeHandler}
                                value={email}
                                label="Email Address"
                                id="email"
                                name="email"
                                validation={
                                    /* istanbul ignore next */ () =>
                                        new ValidationAuthorizationForgot(this.state).one('email')
                                }
                            />
                        </div>
                        <button type="submit" className={s.submit} onClick={this.handleSubmit}>
                            Submit
                        </button>
                        {Boolean(success.length) && <div className={s.success}>{success}</div>}
                        <span
                            role="button"
                            className={s.formSwitcher}
                            onClick={() => visibleTabHandler('login')}
                        >
                            Back to login
                        </span>
                    </form>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    sendForgot,
};

export const ForgotConnected = connect(null, mapDispatchToProps)(Forgot);
